import React, { useMemo } from 'react';
import { Helmet } from 'react-helmet-async';
import { useAtom } from 'jotai/index';
import useTranslations from '../../hooks/useTranslations';
import { pathnameAtom } from '../../atoms/globalAtoms';
import { DICTIONARY } from '../../translations/dictionary';

const PUBLIC_SECTION_TITLES = [
  { path: '/about', dictionaryKey: 'aboutConfigurator' },
  { path: '/instructions', dictionaryKey: 'instructions' },
  { path: '/contact', dictionaryKey: 'contactUs' },
  { path: '/registration', dictionaryKey: 'registration' },
  { path: '/login', dictionaryKey: 'toLogin' },
  { path: '/password', dictionaryKey: 'passwordFormTitle' },
  { path: '/privacy', dictionaryKey: 'privacyTitle' },
];

function Head() {
  const { t, lang } = useTranslations();
  const [pathname] = useAtom(pathnameAtom);

  const title = useMemo(() => {
    const siteTitle = t(DICTIONARY.siteTitle);
    const section = PUBLIC_SECTION_TITLES.find(({ path }) => pathname === path || pathname.startsWith(`${path}/`));
    if (!section) return siteTitle;

    const sectionName = t(DICTIONARY[section.dictionaryKey]);
    return sectionName ? `${siteTitle} - ${sectionName}` : siteTitle;
  }, [lang, pathname]);

  const description = t(DICTIONARY.siteDescription);

  return (
    <Helmet>
      <html lang={lang} />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
    </Helmet>
  );
}

export default Head;
